import { HStack, Text } from '@bpba/ui-components';
import styled from 'styled-components';
import { TypographyProps, typography } from 'styled-system';

export type Tag<T> = {
  title: string;
  start: T;
  end: T;
  exceptionalCases?: T[];
};

type Props<T> = {
  status: T;
  tags: Tag<T>[];
};

export const Breadcrumb = <T,>({ status, tags }: Props<T>) => {
  const lastTagIndex = tags.length - 1;

  function isSelected(tag: Tag<T>) {
    return (tag.start <= status && status <= tag.end) || (tag.exceptionalCases && tag.exceptionalCases.includes(status));
  }

  return (
    <StyledHStack justifyContent="center" fontSize={0}>
      {tags.map((tag, index) => (
        <HStack key={index} width="fit-content">
          <Text margin={0} fontWeight={isSelected(tag) ? '800' : '400'} aria-hidden={!isSelected(tag)}>
            {tag.title}
          </Text>
          {index < lastTagIndex && (
            <Text paddingX={15} margin={0} aria-hidden={true}>
              &gt;
            </Text>
          )}
        </HStack>
      ))}
    </StyledHStack>
  );
};

const StyledHStack = styled(HStack)<TypographyProps>(typography);
